import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Button from '../../../01_atoms/Button';
import SuggestedSearches from './SuggestedSearches';

import styles from './index.module.scss';

const SearchInputField = ({
  onSearchButtonSubmit,
  onChange = () => {},
  value = '',
  placeholder = '',
  inputRef = null,
  onKeyDown = () => {},
  info = '',
  label = '',
  autocompleteOptions = [],
  onOptionClick,
  isLoading = false,
  isRequired = false,
}) => {
  const [isSearchActive, setSearchActive] = useState(true);
  // Hide and show address options when search is active.
  useEffect(() => {
    const element = document.getElementById('address-autocomplete-search__search');
    const checkFocusinSearchContainer = (e) => {
      if (!isSearchActive && element.contains(e.target)) {
        setSearchActive(true);
      } else if (isSearchActive && !element.contains(e.target)) {
        setSearchActive(false);
      }
    };

    const checkClickOutsideOfSearchContainer = (e) => {
      if (!isSearchActive && element.contains(e.target)) {
        setSearchActive(true);
      } else if (isSearchActive && !element.contains(e.target)) {
        setSearchActive(false);
      }
    };

    document.addEventListener('focusin', checkFocusinSearchContainer);
    document.addEventListener('click', checkClickOutsideOfSearchContainer);
    return () => {
      document.removeEventListener('click', checkClickOutsideOfSearchContainer);
      document.removeEventListener('focusin', checkFocusinSearchContainer);
    };
  }, [isSearchActive]);

  return (
    <div className={styles['address-autocomplete-search']} data-analytics="address_search">
      {label && (
        <label className={styles['address-autocomplete-search__label']}>
          Address search{isRequired ? <span> (required)</span> : ''}
        </label>
      )}
      <div
        id="address-autocomplete-search__search"
        className={styles['address-autocomplete-search__search']}
      >
        <div className={styles['address-autocomplete-search__input']}>
          <input
            placeholder={placeholder}
            value={value}
            name="text"
            ref={inputRef}
            onKeyDown={onKeyDown}
            onChange={onChange}
            aria-label="query"
            title="Address search"
            aria-required="false"
            maxLength={200}
            data-component="address-autocomplete-search-input"
            type="search"
            enterKeyHint="search"
          />
        </div>

        <Button
          buttonType="button"
          type="secondary"
          size="large"
          className={`${styles['address-autocomplete-search__button']}`}
          onClick={() => onSearchButtonSubmit(value)}
          data-component="address-autocomplete-submit-search-button"
          isLoading={isLoading}
        >
          Search
        </Button>

        {isSearchActive && !!autocompleteOptions.length && (
          <SuggestedSearches onOptionClick={onOptionClick} options={autocompleteOptions} />
        )}
      </div>
      {info && <div className={styles['address-autocomplete-search__info']}>{info}</div>}
    </div>
  );
};

SearchInputField.propTypes = {
  onKeyDown: PropTypes.func,
  onSearchButtonSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  inputRef: PropTypes.object,
  info: PropTypes.string,
  label: PropTypes.string,
  autocompleteOptions: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
    }),
  ),
  onOptionClick: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  isRequired: PropTypes.bool,
};

export default SearchInputField;
